import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { ConsentProvider } from './contexts/ConsentContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ErrorBoundary from './components/ErrorBoundary';
import { router } from './router';
import { initSentry } from './lib/monitoring';
import { initWebVitalsTracking } from './lib/webVitals';
import { errorLogger } from './lib/errorLogger';
import './index.css';

initSentry().catch(error => {
  console.error('Failed to initialize Sentry:', error);
});
initWebVitalsTracking();

window.addEventListener('error', (event) => {
  errorLogger.logError(
    event.message,
    event.error?.stack,
    {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    }
  );
});

window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
  errorLogger.logError(
    error.message,
    error.stack,
    {
      type: 'unhandledrejection',
      promise: 'Promise rejection',
    }
  );
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <ConsentProvider>
          <AuthProvider>
            <NotificationProvider>
              <RouterProvider router={router} />
            </NotificationProvider>
          </AuthProvider>
        </ConsentProvider>
      </HelmetProvider>
    </ErrorBoundary>
  </StrictMode>
);
